import { CONTENT_PAGE } from './mortgageRatesSections';
import { USState } from './mortgageRatesState';

const sanitizeAnchorHtml = (html: string): string => {
    let output = html;
    const emptyAnchorRe = new RegExp(
        '<a\\b(?:(?!\\b(?:id|name|href|data-|aria-)\\b)[^>])*>[\\s]*<\\/a>',
        'gi'
    );
    const nestedAnchorRe = new RegExp(
        '<a\\b[^>]*>\\s*<a\\b([^>]*)>([\\s\\S]*?)<\\/a>\\s*<\\/a>',
        'gi'
    );
    let prev = '';
    let guard = 0;
    do {
        prev = output;
        output = output.replace(emptyAnchorRe, '');
        output = output.replace(nestedAnchorRe, '<a$1>$2</a>');
        guard += 1;
    } while (output !== prev && guard < 10);
    return output;
};

/**
 * @important
 * navigate to this @link{https://cms-bedrock-prod.int.zgcp-consumer-prod-k8s.zg-int.net/homeloans/wp-admin/post.php?post=3086&action=edit}to edit the page.
 * navigate to this @link{https://cms-bedrock-prod.int.zgcp-consumer-prod-k8s.zg-int.net/homeloans/wp-json/wp/v2/pages/3086/?_fields=cms_blocks} to see the block content in JSON.
 * extract only the array containing the blocks. Starts with [{"blockName"}]...
 * copy the array and paste it in the @link{https://www.freeformatter.com/json-escape.html#before-output} to un-escape the JSON.
 * copy the un-escaped JSON and paste it in the @link{https://jsonformatter.org/} to pretty format the json.
 * paste in CONTENT_PAGE
 */
const replaceStatePlaceholders = (obj: unknown, state: USState): unknown => {
    if (typeof obj === 'string') {
        const withState = obj
            .replace(/{State}/g, state.name)
            .replace(/{StateAbv}/g, state.abbreviation);
        return sanitizeAnchorHtml(withState);
    }

    if (Array.isArray(obj)) {
        return obj.map((item) => replaceStatePlaceholders(item, state));
    }

    if (obj && typeof obj === 'object') {
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            result[key] = replaceStatePlaceholders(value, state);
        }
        return result;
    }

    return obj;
};

export const getMortgageRatesContent = (state: USState) => {
    const content = CONTENT_PAGE.map((item) =>
        replaceStatePlaceholders(item, state)
    );

    return content;
};
